export class PlayerInstallStates {
	Id: number;
	Name: 'All' | 'Installed' | 'Not-Installed' | 'Awaiting Prep' | 'Demo Unit' | 'Spare Unit' | 'Awaiting Activation - Unity Player';
}